module.exports = __webpack_public_path__ + "img/brand-icon.495ed7ec.svg";